export default "__VITE_ASSET__DEoMUMHx__"